// a data store for the bank paybills page
export const BANK_PAYBILLS = [
    { name: "KCB", code: "522522" },
    { name: "NCBA Bank", code: "880100" },
    { name: "Co-operative Bank", code: "400200" },
    { name: "Standard Chartered Bank", code: "329329" },
    { name: "Barclays Bank K LTD", code: "303030" },
    { name: "NIC Bank Limited", code: "488488" },
    { name: "Family Bank Ltd", code: "222111" },
    { name: "CFC Stanbic", code: "600100" },
    { name: "Equity Bank", code: "247247" },
    { name: "National Bank", code: "547700" },
    { name: "Chase Bank", code: "552800" },
    { name: "I & M Bank Limited", code: "542542" },
    { name: "Diamond Trust Bank (DTB)", code: "516600" },
    { name: "Ecobank", code: "700201" },
    { name: "Jamii Bora Bank", code: "529901" },
    { name: "IMPERIAL BANK LTD", code: "800100" },
    { name: "ABC Bank", code: "111777" },
    { name: "Credit Bank", code: "972700" },
    { name: "Consolidated Bank LTD", code: "508400" },
    { name: "Equatorial Commercial Bank", code: "498100" },
    { name: "K-REP BANK", code: "111999" },
    { name: "Transnational Bank", code: "862862" },
    { name: "Post Office Savings Bank", code: "200999" },
    { name: "Gulf African Bank", code: "985050" },
    { name: "Housing Finance Company Ltd", code: "100400" },
    { name: "Bank of Africa (BOA)", code: "972900" },
    { name: "UBA Bank", code: "559900" },
    { name: "Guardian Bank", code: "344501" },
    { name: "Prime Bank", code: "982800" },
    { name: "Guaranty Trust Bank", code: "910200" }
];